import AgentLayout from './AgentLayout';
import SupportTicketsPanel from './SupportTicketsPanel';
export default function AgentSupportTicketsPanel() {
  return <SupportTicketsPanel Layout={AgentLayout} />;
}